export default "__VITE_ASSET__CvcmkjQq__"